<template>
  <div id="app" :style="{ marginTop: headerHeight + 'px' }">
    <Localizer>
      <SessionTimeout />
      <Header id="navbar"/>
      <router-view />
      <Footer />
      <md-speed-dial @click.native="messageModal = true" class="md-fixed md-bottom-right messageBtn">
        <md-speed-dial-target class="btn-info">
          <md-icon class="md-morph-initial">mail</md-icon>
          <md-icon class="md-morph-final">send</md-icon>
        </md-speed-dial-target>
      </md-speed-dial>
      <MessageModal :message="messageModal" @closeModal="messageModal=false" />
    </Localizer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Localizer from '@/components/Localizer'
import SessionTimeout from '@/components/SessionTimeout'
import MessageModal from '@/components/MessageModal'

export default {
  name: 'App',
  data(){
    return {
      messageModal: false,
      headerHeight: 0,
    }
  },
  components: { Header, Footer, Localizer, SessionTimeout, MessageModal },
  methods: {
    getHeaderHeight(){
      const height = $('#navbar').outerHeight();
      this.headerHeight = parseInt(height + 30);
      console.log('Header height: ', this.headerHeight);
    }
  },
  created() {
    window.addEventListener('resize', this.getHeaderHeight)
    this.getHeaderHeight();
  },
  beforeMount(){
    this.getHeaderHeight();
  },
  mounted(){
    this.$nextTick(function() {
      window.addEventListener('resize', this.getHeaderHeight);
      window.addEventListener('load', this.getHeaderHeight);
      //Init
      this.getHeaderHeight()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeaderHeight);
    window.removeEventListener('load', this.getHeaderHeight);
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 100px;
}
.md-dialog {
z-index: 9999999;
}
.md-overlay {
z-index: 99999;
}
.messageBtn {
z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue